module.exports = __webpack_public_path__ + "static/img/qqshare.d225a1b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/qqshare.png
// module id = 0uZc
// module chunks = 6